export default __webpack_public_path__ + "content/media/29.8b676714.jpg";